// extracted by mini-css-extract-plugin
export default {"navDropdown":"TituloViewSection_navDropdown__g3kKv","dropdown-menu":"TituloViewSection_dropdown-menu__86g8w","linkContainer":"TituloViewSection_linkContainer__Mr74G"};